import React  from "react";
import ViewMaterial from "../../components/material/viewmaterial";

export default function Material() {
  return (
    <div className="px-4">
       {/* List of existing materials */}
      <ViewMaterial />
    </div>
  );
}
